// Auth-related functions using API endpoints (no Supabase)

export async function inviteTeamMember(member, companyId) {
  // Get company ID - passed as parameter from TeamPage component
  if (!companyId) {
    throw new Error("No company context. Please ensure you're logged in.");
  }

  const res = await fetch('/api/auth/invite-team-member', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('amlguard_token') || ''}`,
    },
    body: JSON.stringify({
      email: member.email,
      firstName: member.firstName,
      lastName: member.lastName,
      role: member.role || 'AML Analyst',
      permission: member.permission || 'analyst',
      companyId: companyId,
    }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `Invite failed (${res.status})`);
  return data;
}

// Refresh auth token using server-side proxy to avoid CORS
export async function refreshAuthToken() {
  try {
    const token = localStorage.getItem('amlguard_token');
    if (!token) return null;

    const res = await fetch('/api/auth/refresh', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });

    if (res.ok) {
      const { accessToken } = await res.json();
      localStorage.setItem('amlguard_token', accessToken);
      return accessToken;
    }
  } catch (err) {
    console.warn('Token refresh failed:', err);
  }
  return null;
}
